
export type Payment = BasePayment | PaymentWithCreditCard

interface BasePayment {
  readonly totalPrice: number

  /*
   * charge_sheet が取れるレコードと取れないレコードがある?Engine調査中.
   * 将来的に支払金額の内訳詳細を表示する必要が出てきた時に、参照する可能性あり.
   * @see src/ReadModel/Subscription/Contracted/Payment.php
   * @see https://github.com/my-color/front/issues/5573#issuecomment-907995022
   */
  readonly deliveryFee: number | null
  /*
   * charge_sheet が取れるレコードと取れないレコードがある?Engine調査中.
   * 将来的に支払金額の内訳詳細を表示する必要が出てきた時に、参照する可能性あり.
   * @see src/ReadModel/Subscription/Contracted/Payment.php
   * @see https://github.com/my-color/front/issues/5573#issuecomment-907995022
   */
  readonly commission: number | null

  readonly method: string
  readonly method_detail: {}
}
interface PaymentWithCreditCard extends BasePayment {
  readonly method: 'creditcard'
  readonly method_detail: {
    readonly token: string
  }
}

export function paymentWithCreditCard(p: Payment): p is PaymentWithCreditCard {
  return p.method === 'creditcard'
}
